import { UtilitarioService } from "@app/services/utilitario.service";

export class Filtros {

    Titular: string;
    Numero: string;
    DataInicial: string;
    DataFinal: string;
    ContaId: number;
    UnidadeId: number;
    Observacao: string;
    ProcessoId: number;

    constructor() {
        this.DataInicial = UtilitarioService.retornaDataAtualMaisDiasISO(0);
        this.DataFinal = UtilitarioService.retornaDataAtualMaisDiasISO(7);
    }

}